<template>
    <div>
        <!-- contact edit -->
        <d-contact-edit
            v-model      = "edit"
            :contact-id  = "contact ? contact.id : null"
            :company-id  = "contact && contact.company ? contact.company.id : null"
            :customer-id = "customerId"
            :mode        = "mode"
            @saved       = "onSaved"
        />
        <!-- contact edit -->

        <c-list-card
            v-if             = "contact"
            :background      = "background"
            :edit            = "editContact"
            :highlight-color = "statusColor"
            @edit            = "edit = true"
            @selected        = "onSelect"
        >
            <template v-slot:buttons>
                <div style="margin-top: 2px" v-if="combineAllowed && isContactAdmin">
                    <c-toolbar-button
                        tooltip  = "Kontakte zusammenfassen"
                        color    = "primary"
                        icon     = "mdi-set-all"
                        size     = "22"
                        class    = "mt-n1"
                        @click   = "onCombine"
                    />
                </div>
            </template>

            <!-- icons for site assignment -->
            <template v-slot:toolbar>
                <div style="position: relative">
                    <v-tooltip bottom>
                        <template v-slot:activator="{ on, attrs }">
                            <div>
                                <div>
                                    <v-icon
                                        :color = "statusColor"
                                        v-if   ="contact.siteAssignmentType && contact.siteAssignmentType.id > 1"
                                        size   = "21"
                                        v-bind = "attrs"
                                        v-on   = "on"
                                        class  = "pt-1"
                                    >
                                        {{ icon }}
                                    </v-icon>
                                </div>
                            </div>
                        </template>
                        <span>{{ contact.siteAssignmentType.name }}</span>
                    </v-tooltip>
                </div>
                <div v-if="contact.customer" class="customer-restriction">
                    {{ contact.customer.name }}
                </div>
                <c-toolbar-button
                    v-if     = "enableUnassign && (!contact.siteAssignmentType || contact.siteAssignmentType.id === 1)"
                    :tooltip = "$t('contact.dissolve.tooltip')"
                    color    = "red"
                    icon     = "mdi-close"
                    size     = "21"
                    class    = "mt-n1"
                    @click   = "onDissolve"
                />
            </template>
            <!-- icons for site assignment -->

            <!-- title with company and parent contact -->
            <template v-slot:title>
                <div class="w-100 v-flex">
                    <div style="font-size: 12px;" :class="statusColor + '--text'">
                        <span v-if="isCustomerOnsite">i.a. </span><span>{{ company }}<span v-if="contact.tags"> - {{ contact.tags }}</span></span>
                    </div>
                    <v-spacer />
                    <div class="type mr-1">
                        <div class="contact-parent">
                            {{ parent }}
                        </div>
                        <a @click.stop="onMember(contact)">
                            <v-icon
                                v-if="contact.member && contact.member.length > 0"
                                color="primary"
                                size  ="22"
                                style = "margin-top: -7px"
                            >
                                mdi-account-supervisor
                            </v-icon>
                        </a>
                    </div>
                </div>
            </template>
            <!-- title with company and parent contact -->

            <!-- subtitle with contact name and roles -->
            <template v-slot:subtitle>
                <div class="contact-name">
                    <v-tooltip bottom >
                        <template v-slot:activator="{ on, attrs }">
                            <span v-bind = "attrs" v-on   = "on">{{ contact.id }} - {{ contact.firstname }} {{ contact.name }}</span>
                        </template>
                        {{ contact.firstname }} {{ contact.name }}
                    </v-tooltip>
                </div>

                <div class="v-flex" style="margin-top: -3px;">
                    <div v-for="(role, index) in contact.roles" :key="index" class="mr-1">
                        {{ (index === contact.roles.length-1) ? role.name  : role.name + ' + ' }}
                    </div>
                </div>
            </template>
            <!-- subtitle with contact name and roles -->

            <template v-slot:body>
                <v-divider class="mt-2 mb-2" />
                <div style="position:relative;"  v-if="contact">
                    <div v-if="isGlobal && background" style="position: absolute; top: 2px; font-size: 12px; width: 195px">
                        <div class="success white--text" style="border-radius: 4px; text-align: center">
                            Gilt für alle Anlagen
                        </div>
                    </div>
                    <div v-if="isGlobalCustomer && background" style="position: absolute; top: 2px; font-size: 12px; width: 195px;">
                        <div class="success white--text" style="border-radius: 4px; text-align: center; height: 38px">
                            <div>Gilt für alle Anlagen des Kunden</div>
                            <div>{{ contact.customer.name }}</div>
                        </div>
                    </div>
                    <div class="contact-responsibilities">
                        <r-responsibilities
                            v-if="contact.allresponsibilities"
                            :items = "contact.allresponsibilities"
                            :width = "tagwidth"
                            :background-color = "statusColor"
                            :height = "contact.allresponsibilities.length === 4 ? 40 : 60"
                        />
                        <div v-if="incidenttypes.length > 0" class="v-flex">
                            <c-tag
                                :width            = "tagwidth"
                                :label            = "incidenttypes[0].name"
                                :active           = "true"
                                :background-color = "statusColor"
                                class             = "tag"
                            />
                            <div v-if="incidenttypes.length > 1" style="font-size: 11px; padding-left: 5px; padding-top: 4px;">
                                (+ {{ incidenttypes.length - 1 }} weitere)
                            </div>
                        </div>
                    </div>
                    <v-row class="no-frame">
                        <v-col class="no-frame col-auto">
                            <r-phone-numbers
                                :color  = "statusColor + '--text'"
                                :numbers="contact.phonenumbers"
                            />
                        </v-col>
                        <v-col class="no-frame col-auto">
                        </v-col>
                    </v-row>
                </div>
            </template>

            <template v-slot:footer>
                <div class="v-flex" :class="statusColor + '--text'">
                    {{ contact.email}}
                </div>
            </template>

        </c-list-card>
    </div>
</template>

<script>

import CListCard         from "@/modules/core/components/utils/CListCard";
import RPhoneNumbers     from "@/modules/msd/common/components/RPhoneNumbers";
import RResponsibilities from "@/modules/msd/common/components/RResponsibilities";
import CTag              from "@/modules/core/components/utils/CTag";
import DContactEdit      from "@/modules/msd/company/contact/components/controlls/DContactEdit";
import Core              from "@/modules/core/service/Core";
import Contact           from "@/modules/msd/company/contact/service/Contact";
import Company from "@/modules/msd/company/common/service/Company";
import CToolbarButton from "@/modules/core/components/utils/CToolbarButton";

export default {
    name: "CContactCard",
    components: {
        CToolbarButton,
        DContactEdit,
        CTag,
        RResponsibilities,
        RPhoneNumbers,
        CListCard,
    },

    props: {
        contact: {
            required: false,
            type    : Object,
            default: function () {
                return {
                    id                : null,
                    firstname         : null,
                    siteAssignmentType: null,
                    customer          : null,
                    email             : null
                };
            }
        },

        editContact: {
            required: false,
            type    : Boolean,
            default : function () {
                return true;
            }
        },

        background: {
            required: false,
            type    : String,
            default : function () {
                return null;
            }
        },

        enableUnassign: {
            required: false,
            type    : Boolean,
            default : function () {
                return false;
            }
        },

        customerId: {
            required: false,
            type    : Number,
            default: function () {
                return null;
            }
        },

        mode: {
            required: false,
            type    : String,
            default : () => {
                return null;
            }
        },

        combineAllowed: {
            required: false,
            type    : Boolean,
            default : function () {
                return false;
            }
        }
    },

    data: () => ({
        edit        : false,
        orgunitIndex: 0,
        tagwidth: 96,
    }),

    computed: {
        isContactAdmin () {
            return Core.security.isContactAdmin();
        },

        company () {
            if (!this.contact || !this.contact.company) {
                return null;
            }

            return this.contact.company.name;
        },

        icon () {
            if (!this.contact.siteAssignmentType) {
                return null;
            }

            if (this.contact.siteAssignmentType.id === 2) {
                return "mdi-earth"
            }

            if (this.contact.siteAssignmentType.id === 3) {
                return "mdi-account-circle"
            }

            return null;
        },

        statusColor () {
            if (!this.contact) {
                return "primary";
            }

            if (this.contact.status.id === 4) {
                return "secondary";
            }

            if (this.contact.status.id === 5) {
                return "error";
            }

            return "primary";
        },

        isCustomer () {
            if (!this.contact || !this.contact.company) {
                return false;
            }

            return this.contact.company.roles.find(r => r.id === Company.roles.customer);
        },

        isCustomerOnsite () {
            return this.isCustomer && this.contact.roles.find (role => role.id === 2);
        },

        isGlobal () {
            if (!this.contact) {
                return false;
            }

            return Contact.isGlobal(this.contact);
        },

        isGlobalCustomer () {
            if (!this.contact) {
                return false;
            }

            return Contact.isGlobalCustomer(this.contact);
        },

        companyAdd () {
            return ""; //this.contact.companies.length !== 0 ? this.contact.companies [0].nameAdd : "";
        },

        city () {
            return ""; //this.contact.companies.length !== 0 ? this.contact.companies [0].zip + " " + this.contact.companies [0].city : "";
        },

        street () {
            return ""; //this.contact.companies.length !== 0 ? this.contact.companies [0].street : "";
        },

        parent () {
            if (!this.contact.parent) {
                return null;
            }

            return this.contact.parent.name
        },

        incidenttypes () {
            if (!this.contact.incidenttypes) {
                return [];
            }

            return this.contact.incidenttypes.slice().sort((l,r) => {
               return l.name.localeCompare (r.name);
            });
        }
    },

    methods: {
        onSelect () {
            Core.fire.selected(this, this.contact);
        },

        onCombine () {
            this.$emit("combine", this.contact);
        },

        onMember () {
            this.$emit("member", this.contact);
        },

        onDissolve () {
            this.$emit("dissolve", this.contact);
        },

        onSaved (contact) {
            Core.fire.saved(this, contact);
        }
    }
}
</script>

<style scoped>

.contact-parent {
    padding-top: 3px;
    color: black;
    font-size: 12px;
}

.contact .header {
    height: 80px;
}

.contact-name {
    font-size: 16px;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    max-width: calc(100% - 1px);
    margin-top: -2px;
    z-index: 100;
}

.contact .type {
    padding-top: 2px;
}

.contact .type,
.contact .company,
.contact .company-add,
.contact .adress,
.contact .email {
    font-size: 13px;
    height: 18px;
}

.contact .email {
}

.contact .company,
.contact .company-add {
    max-width: 100%;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
}

.contact-responsibilities {
    position: absolute;
    width: 50%;
    right: 0;
    top: 0px
}

.tag {
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    padding-left: 5px;
    margin-left: 2px;
}

.customer-restriction {
    font-size: 8px;
    position: absolute;
    height: 400px;
    writing-mode: vertical-lr;
    right: 2px;
    top: 17px;
}


</style>